/* tslint:disable */
/* eslint-disable */
export enum FileProcessingStatus {
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
}
